<template>
	<div class="container">
		<div class="main">
			<div class="main-nav">
				<div class="main-nav-list">
					<div class="main-nav-title">
						<span></span>
						<h3>消息中心</h3>
					</div>
					<ul>
						<li :class="[activePath=='/commentReply'?'active':'']">
							<router-link to="/commentReply">评论与回复</router-link>
						</li>
						<li :class="[activePath=='/systemMessage'?'active':'']">
							<router-link to="/systemMessage">系统消息</router-link>
						</li>
						<li :class="[activePath=='/likeFllow'?'active':'']">
							<router-link to="/likeFllow">点赞&关注</router-link>
						</li>
					</ul>
				</div>
				
			</div>
			<div class="content">
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'message',
		components: {
			
		},
		data(){
			return {
				activePath: '/commentReply'
			}
		},
		watch: {
			$route(to, from) {
				let path = to.path
				this.activePath = path
			}
		},
		created(){
			this.activePath = this.$route.fullPath
		},
		methods: {
			
		}
	}
</script>

<style lang="less" scoped>
	.main{
		display: flex;
		width: 1200px;
		margin: 20px auto;
		padding: 20px;
		background: #fff;
		border-radius: 12px;
		box-sizing: border-box;
		.main-nav{
			.main-nav-list{
				.main-nav-title{
					display: flex;
					align-items: center;
					margin-bottom: 8px;
					h3{
						font-size: 16px;
						font-weight: bold;
					}
					span{
						width: 4px;
						height: 18px;
						margin-right: 4px;
						background: #CF171D;
						border-radius: 2px;
						content: ' ';
						display: block;
					}
				}
			}
			ul{
				padding-top: 2px;
				li{
					width: 138px;
					height: 28px;
					margin-top: 10px;
					margin-right: 30px;
					padding-left: 15px;
					font-size: 16px;
					color: var(--color-text-opacity);
					line-height: 28px;
					box-sizing: border-box;
					a{
						display: block;
					}
					a:hover{
						text-decoration: none;
					}
				}
				li.active{
					background: rgba(207,23,29,.1);
					font-weight: bold;
					font-size: 16px;
					color: var(--color-text-a);
					a{
						color: var(--color-text-a);
					}
				}
			}
		}
		.content{
			flex: 1;
			padding-left: 20px;
			border-left: 1px solid var(--color-border);
			.empty{
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				width: 260px;
				margin: 60px auto;
				img{
					width: 260px;
					height: 230px;
				}
				span{
					padding: 20px 0 30px;
					color: var(--color-text-opacity);
				}
				.public-btn{
					display: block;
					width: 88px;
					height: 34px;
					background: #CF171D;
					border-radius: 16px;
					line-height: 34px;
					text-align: center;
					color: #fff;
				}
			}
			/deep/ .el-tabs__active-bar{
				background-color: #CF171D;
			}
			/deep/ .el-tabs__item.is-active{
				color: #CF171D;
			}
			/deep/ .el-tabs__item:hover{
				color: #CF171D;
			}
		}
	}
</style>
